import { Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Header from "../../components/Header";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingTop: "64px",
    background: `url(${"https://s3.us-east-2.amazonaws.com/www.ethlink.tech/ethereum.png"}) no-repeat center center fixed`,
    "-webkit-background-size": "cover",
    "-moz-background-size": "cover",
    "-o-background-size": "cover",
    "background-size": "cover",
    "min-height": "100%",
    "@media (min-width: 900px)": {
      "min-width": "1024px",
    },
    overflow: "hidden",
    
    /* Set up proportionate scaling */
    width: "100%",
    height: "auto",
    
    /* Set up positioning */
    position: "fixed",
    top: 0,
    left: 0,
  },
  paperStyle: {
    "@media (min-width: 700px)": {
      marginLeft: "10px",
      marginRight: "10px",
    },
  },
  header: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "#F0B90B",
    textAlign: "left",
    fontSize: "36px",
    "@media (max-width: 900px)": {
      fontSize: "18px",
    },
  },
  subtitle: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: "bold",
    color: "#F0B90B",
    wordWrap: "break-word",
    "@media (max-width: 900px)": {
      fontSize: "14px",
    },
  }
}));

const Home = () => {
  const { root, paperStyle, header,subtitle } = useStyles();
  const auth = useSelector((state) => state.auth);
  if (auth.authenticate) {
    return <Redirect to={`/app`} />;
  }
  return (
    <div className={root}>
      <Grid container spacing={8} direction="column">
        <Grid item xs={12}>
          <Header />
        </Grid>
        <Grid item container justifyContent="center" alignContent="flex-end">
          <div className={paperStyle}>
            <Typography variant="h3" className={header} component="h1">
              Capchain V1.0
            </Typography>
            <Typography className={subtitle}  variant="subtitle1" component="h3">
              Platform to onboard Web2 applications to Web3 and tokenisation in blockchain technology
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;
